import styled from 'styled-components';
import NormalImg from '../Img';

const Img = styled(NormalImg)`
  max-width: 100%;
`;

export default Img;
